module.exports = __webpack_public_path__ + "ba8b5434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/logo.svg
// module id = 739
// module chunks = 2